import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(environment.loginUrl, '_blank');
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'Royal Borough of Windsor and Maidenhead',
		src: 'assets/rbwm_logo_header_2.svg',
		href: 'https://www.rbwm.gov.uk/',
	};

	navigation: NavLink[] = [
		{
			text: 'My RBWM',
			url: 'https://forms.rbwm.gov.uk/myaccount?_gl=1*qj4nqf*_ga*MTczODQ3Mzk1My4xNzY0NTk1NjY0*_ga_B1S76ZFQXK*czE3NjQ1OTU2NjMkbzEkZzEkdDE3NjQ1OTU2ODUkajM4JGwwJGgw',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://scripts.rbwm.gov.uk/scripts/search/?zoom_query=${formatted}&zoom_cat=3&op=Search&form_build_id=form-0-k2tn7F1VvWBuiRKQlCfmuU8Hv0MAVpMwbYo_61O-A&form_id=bbd_zoom_search_form&_gl=1*o2fyfi*_ga*MTczODQ3Mzk1My4xNzY0NTk1NjY0*_ga_B1S76ZFQXK*czE3NjQ1OTU2NjMkbzEkZzEkdDE3NjQ1OTU2ODUkajM4JGwwJGgw`;
		window.location.href = url;
	}
}
